import React, { FC, useCallback } from 'react'
import styles from 'styles/components/card.module.scss'
import { StaffType } from 'types/staff'
import { Card, CardGreyHeadline } from 'components/Card'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getStaffs } from 'reducks/staff/selectors'
import MemberCardRow from './MemberCardRow'
import { TextButton } from 'components/Button'
import { push } from 'connected-react-router'
import { FlexRow } from 'components/Flex'

const MemberCard: FC = () => {
  const dispatch = useDispatch()
  const staffs: StaffType[] = useSelector((state: State) => getStaffs(state))
  const navigateToInviteMemberPage = useCallback(() => dispatch(push('/account/invite_member')), [dispatch])
  return (
    <Card>
      <h3 className={styles.member__title}>メンバーを管理する</h3>
      <Spacer size={20} />
      <CardGreyHeadline headline={'メンバー'} />
      <Spacer size={16} />
      {staffs.map((staff) => (
        <MemberCardRow key={staff.uid} staff={staff} />
      ))}
      <FlexRow justifyContent={'center'}>
        <TextButton label={'新しくメンバーを招待する'} onClick={navigateToInviteMemberPage} />
      </FlexRow>
    </Card>
  )
}

export default MemberCard
